import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {  FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
declare var $: any;
import { Mbp4aService } from 'src/app/services/mbp4a.service';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';


@Component({
  selector: 'app-mbp4alist',
  templateUrl: './mbp4alist.component.html',
  styleUrls: ['./mbp4alist.component.css']
})
export class Mbp4alistComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMbp: DataTables.Settings = {};
  registerDirectorList: any[];
  nameInterestedDirector: any[];
  dtTriggerMbp: Subject<any> = new Subject();
  response: boolean;
  deleteMbpId: any;
  nameOfTheInterestedDirector: any;
  nameOfTheParty: any;
  transactionType: any;
  dateOfContract: any;
  dateOfContractTo: any;
  dateOfArrangement: any;
  dateOfArrangementTo: any;
  mbpForm: FormGroup;
  masterDirectorList: any[];
  editParticularId: any;
  isSearchDivVisible = false;
  constructor(private mbp4Service: Mbp4aService, private router: Router, private directorMasterService: DirectorMasterService, 
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
    this.dtOptionsOfMbp = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,

      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [6] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MBP-04(A) Masters',
          title: 'MBP-04(A) Masters',
          extend: 'excel',
          exportOptions: {
            columns: [1, 3, 4, 5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.getMbpList();
    this.getMasterDirector();

  }

  adjustdirectormasterTable() {
    setTimeout(() => {
      $("#directormasterMbp4Table").DataTable().columns.adjust().draw();
    }, 200);
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterMbp4Table").DataTable().columns.adjust().draw();
    });
  }

  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp4a','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getMbpList() {

    this.registerDirectorList = [];
    this.mbp4Service.getMbpList({ isSearch: false }).subscribe(registerList => {
      $("#directormasterMbp4Table").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerMbp.next();
      // setTimeout(() => {
      //   this.dtTriggerMbp.next();
      // }, 200);
    });
  }

  getMasterDirector() {

    this.nameInterestedDirector = [];
    var filterDate = {
      FromDate: null,
      ToDate: null,
    }

    this.directorMasterService.getMasterDirector(filterDate)
      .subscribe(masterDirectorList => {
        this.masterDirectorList = masterDirectorList.directorList;
        this.dtTriggerMbp.next();
      });
  }
  confirmDelete(id) {
    this.deleteMbpId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteMbpData() {
    this.mbp4Service.deleteMbpData(this.deleteMbpId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#directormasterMbp4Table").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
          this.getMbpList();
        } else {
          this.alert.error(response.message);
        }


      });

  }

  editMbpDetails(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp4a','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/mbp4a/edit/', _id]);
  }
  getMbpById(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp4a','getMBPDetailsById',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['mbp4a/getMBPDetailsById/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;

    var searchParam =
    {
      "nameOfTheInterestedDirector": this.nameOfTheInterestedDirector,
      "transactionType": this.transactionType,
      "dateOfContract": this.setDate(this.dateOfContract),
      "dateOfContractTo": this.setDate(this.dateOfContractTo),
      "dateOfArrangement": this.setDate(this.dateOfArrangement),
      "dateOfArrangementTo": this.setDate(this.dateOfArrangementTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#directormasterMbp4Table").DataTable().destroy();
    this.mbp4Service.getMbpList(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerMbp.next();
    });
  }
  clearAdvSearch() {
    this.nameOfTheInterestedDirector = '';
    this.transactionType = '';
    this.dateOfContract = '';
    this.dateOfContractTo = '';
    this.dateOfArrangement = '';
    this.dateOfArrangementTo = '';

    $("#directormasterMbp4Table").DataTable().destroy();
    this.getMbpList();
  }

  transactionTypeChange() {
    if (this.transactionType == 'contract') {
      this.dateOfArrangement = '';
      this.dateOfArrangementTo = '';
    } else {
      this.dateOfContract = '';
      this.dateOfContractTo = '';
    }
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {};
    if (this.transactionType == 'contract') {
      object = {
        id: null,
        fromDate: this.dateOfContract,
        toDate: this.dateOfContractTo,
        name: this.nameOfTheInterestedDirector,
        param1: this.transactionType
      }
    } else if (this.transactionType == 'arrangement') {
      object = {
        id: null,
        fromDate: this.dateOfArrangement,
        toDate: this.dateOfArrangementTo,
        name: this.nameOfTheInterestedDirector,
        param1: this.transactionType
      }
    } else {
      object = {
        id: null,
        fromDate: null,
        toDate: null,
        name: this.nameOfTheInterestedDirector,
        param1: this.transactionType
      }
    }

    this.mbp4Service.generateMbp4aDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
        // this.downloadPdfDocument(companyId);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mbp4Service.downloadMbp4aFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.mbp4Service.downloadMbp4aPdfFile(id, 'Multi');
  }

}